import { useCacheQuery } from '../../../hooks/use-cache-query';
import { GetOpenRegistrationCountDocument } from '../../types/api/graphql';

/** Number of registrations still waiting for a decision — the menu badge. */
export function useOpenRegistrationCount(
  healthProviderId: string | null | undefined,
  skip?: boolean
) {
  const {
    data: openRegistrationCountData,
    loading: openRegistrationCountLoading,
  } = useCacheQuery(GetOpenRegistrationCountDocument, {
    variables: {
      healthProviderId: healthProviderId ?? '',
    },
    skip: skip === true || !healthProviderId,
  });

  return {
    data: openRegistrationCountData?.openRegistrationCount ?? 0,
    loading: openRegistrationCountLoading,
  };
}
